import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    encapsulation: ViewEncapsulation.None
})

export class LoginComponent implements OnInit {

    formData: FormGroup;
    userName: string;
    password: string;

    constructor(
        private authService: AuthService,
        private router: Router) { }

    ngOnInit(): void {
        this.formData = new FormGroup({
            userName: new FormControl(""),
            password: new FormControl("")
        });
    }

    onClickSubmit(data: any) {
        this.userName = data.userName;
        this.password = data.password;

        this.authService.login(this.userName, this.password)
            .subscribe(data => {
                if (data)
                    this.router.navigate(['/admin/home']);
            });
    }
}